import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DetailTemplate from '../../common/template/DetailTemplate';
import CostCalcLockContainer from '../../../containers/projectmng/costcalc/CostCalcLockContainer';
import PurchaseBillHistoryContainer from '../../../containers/projectmng/bill_mng/PurchaseBillHistoryContainer';
import SalesBillFormContainer from '../../../containers/projectmng/bill_mng/SalesBillFormContainer';
import SalesBillPlanFormContainer from '../../../containers/projectmng/bill_mng/SalesBillPlanFormContainer';
import SalesBillHistoryContainer from '../../../containers/projectmng/bill_mng/SalesBillHistoryContainer';
import * as chanceApi from '../../../lib/api/chance';
import { useSnackbar } from 'notistack';

import { setProject } from '../../../modules/projectModule/project';
const SalesBillConfirmReqTemplate = () => {
  const { project } = useSelector(({ projectModule }) => ({
    
    project: projectModule.project.project,
  }));
  const [isLocked, setIsLocked] = useState();  
  const [issueNo, setIssueNo] = useState();
  const { enqueueSnackbar } = useSnackbar();
 const dispatch = useDispatch();
  useEffect(() => {
    // project 객체나 그 안의 lockYn 값이 변경될 때마다 실행
    if (project?.invoiceToBe) {
      const currentLockStatus = project.invoiceToBe.lockYn === 'Y';
      setIsLocked(currentLockStatus);
    }
  }, [project?.invoiceToBe?.lockYn]); // 특정 값의 변화를 감시

  // 2. 클릭 핸들러
  const handleLockClick = async (e) => {
    e.stopPropagation();

    // 1. 바뀔 값을 미리 계산 (상태 변경 전)
    const nextLockedStatus = !isLocked; 
    const lockValue = nextLockedStatus ? 'Y' : 'N';

    // 2. 상태 업데이트 (UI 반영)
    setIsLocked(nextLockedStatus);

    const invoiceToBe = {
      prjUuid: project?.prjUuid,
      lockYn: lockValue, // 계산된 최신 값 전송
    };

    try {
      const res = await chanceApi.changeInvoiceLock(invoiceToBe);

      if (res.data) {
        enqueueSnackbar(`매출 계산서 발행 예정 내역 ${nextLockedStatus ? '잠금' : '해제'} 완료`, {
          variant: 'success',
          
        });
        dispatch(setProject(res.data.info));
      }
    } catch (err) {
      // 에러 발생 시 상태를 다시 원래대로 복구 (선택 사항)
      setIsLocked(isLocked); 
      
      let message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <Box
        sx={{
          py: 2,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2" color={'error.main'} component="div">
          받은 발주서 / 보낸 발주서를 업로드 해야 세금계산서 발행이 가능합니다.
          <br />
          작성 여부를 확인하십시오.
        </Typography>
      </Box>

      <DetailTemplate title="원가 산출 내역">
        <CostCalcLockContainer project={project} />
      </DetailTemplate>

      {/* 수정된 부분: props 전달 문법 오류 해결 */}
      <DetailTemplate title="매입 계산서 매입 등록 내용">
        <PurchaseBillHistoryContainer project={project} />
      </DetailTemplate>

      <DetailTemplate title="매출 계산서 매출 등록 내용">
        <SalesBillHistoryContainer 
          project={project}  
          setIssueNo={setIssueNo} 
        />
      </DetailTemplate>
      <DetailTemplate title="매출 계산서 발행 요청 내역">
        <SalesBillFormContainer project={project} issueNo={issueNo} />
      </DetailTemplate>

      <DetailTemplate title="매출 계산서 발행 예정 내역" isLocked={isLocked} handleLockClick={handleLockClick} hideLock={true} prjTyp={project?.prjTyp}>
        <SalesBillPlanFormContainer project={project} />
      </DetailTemplate>
    </Box>
  );
};

export default SalesBillConfirmReqTemplate;
